import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { InteractionType, KeyValues3, LocalService, PageKey, RelationShipRole, Status, TriggeredEvent } from '../../../service/local.service';
import { SellerManagementService } from '../../../service/seller-management.service';
import { ProductCategoryConfigComponent } from '../../popups/product-category-config/product-category-config.component';

@Component({
  selector: 'app-product-categories',
  templateUrl: './product-categories.component.html',
  styleUrls: ['./product-categories.component.scss']
})
export class ProductCategoriesComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["product_categories"]; items: KeyValues3[];
  ctryCode: string = ''; businessId: string = ''; interactionType = 0; maxBodyHeight = 0;
  RelationShipRole = RelationShipRole; isShowDeleted = false;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private sellerManagementService: SellerManagementService, private route: ActivatedRoute, private modalService: NgbModal, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.configurationManagementService.ensurePageActions(PageKey.ProductCategories, this.businessId);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.sellerManagementService.getProductCategories(this.businessId, !this.isShowDeleted).subscribe(result => {
        this.items = result;
      });
    }
  }

  openProductCategory(id = '') {
    const modalRef = this.modalService.open(ProductCategoryConfigComponent, { size: 'sm' });
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.businessId = this.businessId;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        this.onLoad();
      }
    });
  }

  onRemove(strId) {
    this.sellerManagementService.deleteProductCategory(strId).subscribe(result => {
      if (result.status == Status.Success)
        this.items = this.items.filter(x => x.key != strId);
    });
  }
}
